import { useMobile } from "@/hooks";
import { CheckCircular } from "@monsterindia/global-ui-components";
import React from "react";

import { useProfileData } from "@/components/settings/contents/profileSettings";

const SuccessMessage: React.FC = () => {
  const isMobile = useMobile();
  const { profileHeading, disabledSuccessMsg } =
    useProfileData?.profileAutoUpdate || {};
  return (
    <div className={`${isMobile ? "h-[360px]" : "h-60"}`}>
      {isMobile && (
        <>
          <div className="px-4 py-2 text-left text-base font-bold">
            {profileHeading}
          </div>
          <div className="bg-border-moderate h-[1px] w-full"></div>
        </>
      )}
      <div
        className={`m-4 flex flex-col items-center text-sm ${isMobile ? "pt-10" : "pt-12"}`}
      >
        <CheckCircular width="32" height="32" fill="#228568" />
        <div className="inline-flex w-[328px] flex-col items-center justify-start bg-white pt-4">
          {disabledSuccessMsg?.length
            ? disabledSuccessMsg.map((msg, index) => (
                <span
                  key={index}
                  className="text-center text-base font-bold leading-normal"
                >
                  {msg}
                </span>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default SuccessMessage;
